import { Box, styled } from "@mui/material";
import { ediphiPalette } from "../../styles/colors";

export const Card = styled(Box)(({ theme }) => ({
  borderRadius: "8px",
  background: ediphiPalette.surface,
  padding: theme.spacing(2),
  // paddingTop: theme.spacing(2.5),
  // paddingBottom: theme.spacing(2.5),
  // paddingLeft: theme.spacing(3),
  // paddingRight: theme.spacing(3),
  display: "flex",
}));
